import { Form, Select } from 'antd'
import UpsertContact from './UpsertContact'
import { useEffect } from 'react'

const actions = [
  {
    label: 'Atualizar Contato',
    value: 'UPSERT_CONTACT',
  }
]

export default function CRMForm({ form, fieldName, parameters }) {
  const type = Form.useWatch(['actions', fieldName, 'action', 'type'], form)

  useEffect(() => {
    form.setFieldValue([fieldName, 'action'], {})
  }, [type, form, fieldName])

  return (
    <>
      <Form.Item label={'Tipo de ação'} name={[fieldName, 'action', 'type']}>
        <Select options={actions} placeholder={'Selecione o tipo de ação'} />
      </Form.Item>
      {type === 'UPSERT_CONTACT' && <UpsertContact parameters={parameters} fieldName={fieldName} />}
    </>
  )
}
